import Proxy from './Proxy';

class OfficeLaborProxy extends Proxy {
    constructor(parameters = {}) {
        super('/general-setting', parameters);
    }
}

export default OfficeLaborProxy;
